import * as Types from '../constants/Types';
import Category from './../models/Category';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isFetching: false,
    isFetched: false,
    categories: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        category: new Category(),
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.CATEGORY_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.CATEGORY_LIST_ALL_ACTION:
            return { ...state, isFetching: true };
        case Types.CATEGORY_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                categories: action.categories,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.CATEGORY_LIST_ALL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                listCategories: action.listCategories,
            };
        case Types.CATEGORY_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, categories: [] };
        case Types.CATEGORY_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.CATEGORY_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: { category: action.category, }
            };
        case Types.CATEGORY_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.CATEGORY_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.CATEGORY_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.CATEGORY_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.CATEGORY_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.CATEGORY_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.CATEGORY_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.CATEGORY_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.CATEGORY_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.CATEGORY_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.CATEGORY_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        default:
            return state;
    }
}
